export enum TipoPadraoNota {
  PRE_IMPRESSA = 'PRE_IMPRESSA',
  AUTO_IMPRESSOR = 'AUTO_IMPRESSOR',
  MANUAL = 'MANUAL',
  VENDA_COMUM = 'VENDA_COMUM',
  ELETRONICA = 'ELETRONICA',
}
